import { useHistory } from 'react-router-dom';
import { useAppDispatch } from '@/redux/hooks';
import { applyFilter, clearFilters, setCurrentTable } from '@/redux/slices/dataTableSlice';

export const useGoToCreatedOrder = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  return (orderId: string) => {
    dispatch(setCurrentTable('orders'));
    dispatch(clearFilters());
    dispatch(applyFilter({ type: 'filter_id', selections: [orderId, 'order_hid_filter'] }));
    history.push('/orders');
  };
};
